var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('div', {
    staticClass: "mrs-news-syllables-container"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "type-syllables"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.currentRound.instructions)))])]), _c('div', {
    staticClass: "chalkboard-text-container"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.fullWordDisplay)
    }
  })]), _c('img', {
    attrs: {
      "src": _vm.chalkBoardTeacherImage,
      "alt": ""
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.syllablesLeft === 0,
      expression: "syllablesLeft === 0"
    }],
    class: {
      'selection-container': true,
      isMobile: _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "definitions-container"
  }, _vm._l(_vm.definitionActions, function (action, idx) {
    return _c('div', {
      key: idx,
      class: {
        'format-instructions-text': true,
        isMobile: _vm.isMobile
      },
      attrs: {
        "track-by": idx
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(((idx + 1) + ". "))
      }
    }), _c('span', {
      class: action.class
    }, [_vm._v(_vm._s(_vm._f("capitalize")(action.instruction)) + " ")]), _c('span', {
      domProps: {
        "textContent": _vm._s(action.text)
      }
    })]);
  }), 0), _c('div', {
    staticClass: "actions-container"
  }, [_c('TextFormattingButtons', {
    attrs: {
      "options": _vm.optionsTextFormattingButtons
    }
  })], 1), _c('div', {
    staticClass: "text-to-format-container"
  }, _vm._l(_vm.definitionActions, function (word, idx) {
    return _c('div', {
      key: idx,
      class: {
        'text-to-format': true,
        isMobile: _vm.isMobile
      },
      attrs: {
        "id": word.id,
        "track-by": idx
      }
    }, [_c('span', {
      attrs: {
        "tabindex": "-1"
      },
      domProps: {
        "textContent": _vm._s(word.text)
      },
      on: {
        "mousedown": _vm.enableSelection,
        "mouseleave": _vm.saveSelection,
        "blur": _vm.disableSelection
      }
    })]);
  }), 0), _c('div', {
    staticClass: "facts-stage"
  }, _vm._l(_vm.factsSteps, function (factStep, idx) {
    return _c('div', {
      key: idx,
      class: factStep.className,
      attrs: {
        "track-by": idx
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": factStep.stepIndex,
        "text": factStep.answer
      }
    })], 1);
  }), 0)])]), _c('div', {
    staticClass: "right"
  }, _vm._l(_vm.syllables, function (syllable, idx) {
    return _c('div', {
      key: idx,
      attrs: {
        "track-by": idx
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": syllable.stepIndex,
        "text": syllable.answer
      }
    })], 1);
  }), 0), _c('div', {
    attrs: {
      "id": "chalkboard"
    }
  })]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }